import React from 'react';
import { RecoilRoot } from 'recoil';
import { Main } from './components/Main';
export function ObjectView(_ref) {
  let {
    noRecoilRoot,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(RecoilRoot, null, /*#__PURE__*/React.createElement(Main, props));
}